const BASE = process.env.REACT_APP_BACKEND_URL;

async function req(path, opts = {}) {
  const res = await fetch(`${BASE}/api${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) {
    const err = new Error("Request failed");
    err.status = res.status;
    try { err.body = await res.json(); } catch (e) { /* ignore */ }
    throw err;
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res;
}

export const adminApi = {
  me: () => req("/admin/me"),
  session: (session_id) => req("/admin/session", { method: "POST", body: JSON.stringify({ session_id }) }),
  logout: () => req("/admin/logout", { method: "POST" }),
  dashboard: () => req("/admin/dashboard"),
  leads: (qs) => req("/admin/leads" + (qs ? `?${qs}` : "")),
  lead: (id) => req("/admin/leads/" + id),
  setStatus: (id, status) => req(`/admin/leads/${id}/status`, { method: "PATCH", body: JSON.stringify({ status }) }),
  addNote: (id, text) => req(`/admin/leads/${id}/notes`, { method: "POST", body: JSON.stringify({ text }) }),
  addTag: (id, tag) => req(`/admin/leads/${id}/tags`, { method: "POST", body: JSON.stringify({ tag }) }),
  removeTag: (id, tag) => req(`/admin/leads/${id}/tags/${encodeURIComponent(tag)}`, { method: "DELETE" }),
  assign: (id, assigned_to) => req(`/admin/leads/${id}/assign`, { method: "PATCH", body: JSON.stringify({ assigned_to }) }),
  bulkStatus: (lead_ids, status) => req("/admin/leads/bulk/status", { method: "POST", body: JSON.stringify({ lead_ids, status }) }),
  bulkTag: (lead_ids, tag) => req("/admin/leads/bulk/tag", { method: "POST", body: JSON.stringify({ lead_ids, tag }) }),
  del: (lead_ids, permanent = false) => req("/admin/leads/delete", { method: "POST", body: JSON.stringify({ lead_ids, permanent }) }),
  restore: (lead_ids) => req("/admin/leads/restore", { method: "POST", body: JSON.stringify({ lead_ids }) }),
  resend: (id) => req(`/admin/leads/${id}/resend`, { method: "POST" }),
  share: (payload) => req("/admin/leads/share", { method: "POST", body: JSON.stringify(payload) }),
  allowlist: () => req("/admin/allowlist"),
  setAllow: (email, active) => req("/admin/allowlist", { method: "POST", body: JSON.stringify({ email, active }) }),
  audit: (qs) => req("/admin/audit" + (qs ? `?${qs}` : "")),
  exportUrl: (qs) => `${BASE}/api/admin/export${qs ? `?${qs}` : ""}`,
};

export function goToGoogleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/masteradmin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export const SOURCE_META = {
  discover_assessment: { label: "MapMyKid Discover", chip: "bg-violet-100 text-violet-700", dot: "#7c3aed" },
  assessment_booking: { label: "Assessment Booking", chip: "bg-emerald-100 text-emerald-700", dot: "#059669" },
  business_inquiry: { label: "Business Inquiry", chip: "bg-amber-100 text-amber-700", dot: "#d97706" },
  school_inquiry: { label: "School Inquiry", chip: "bg-sky-100 text-sky-700", dot: "#0284c7" },
  contact_form: { label: "Contact Form", chip: "bg-slate-200 text-slate-700", dot: "#64748b" },
  newsletter_signup: { label: "Newsletter", chip: "bg-pink-100 text-pink-700", dot: "#db2777" },
  other: { label: "Other", chip: "bg-zinc-200 text-zinc-700", dot: "#71717a" },
};

export const STATUS_META = {
  "New": "bg-blue-100 text-blue-700",
  "Contacted": "bg-indigo-100 text-indigo-700",
  "Qualified": "bg-violet-100 text-violet-700",
  "Booked / Converted": "bg-emerald-100 text-emerald-700",
  "Not Interested / Lost": "bg-rose-100 text-rose-700",
};

export function buildQs(obj) {
  const p = new URLSearchParams();
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v !== "" && v !== null && v !== undefined && !(Array.isArray(v) && v.length === 0)) {
      p.set(k, Array.isArray(v) ? v.join(",") : v);
    }
  });
  return p.toString();
}

export function srcLabel(s) {
  return (SOURCE_META[s] || { label: s }).label;
}
